import React from 'react';
import { ProfileSideBar, Header } from '../component';
import { Outlet } from 'react-router';
const ProfileLayout = () => {
  let profileSibebar = JSON.parse(localStorage.getItem('profileSidebar'));

  return (
    <>
      <Header />
      <main className="bg-third-light min-vh-100 position-relative">
        <div className="d-flex w-100 min-vh-100 position-relative">
          <div className="col-lg-2 col-md-9 col-12 px-0 d-lg-flex flex-column bg-third-light d-none">
            <ProfileSideBar reload={profileSibebar?.currentIndex ?? 0} />
          </div>
          <div className="profile-btn-focus col-lg-10 col p-0 bg-third-dark text-primary">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};
export default ProfileLayout;
